import React, { useMemo } from 'react';
import { createCn } from '../../../helpers/utils';
import { formatSecondsShort } from '../utils/audio-segments';
import classes from '../styles.module.scss';

const cn = createCn('file', classes);

type Slice = {
  label: string;
  color: string;
  percent: number;
};

type Props = {
  slices: Slice[];
  centerValue: string;
  centerLabel?: string;
};

const SpeakerDonutChart: React.FC<Props> = ({ slices, centerValue, centerLabel = 'речь' }) => {
  const gradient = useMemo(() => {
    let acc = 0;
    const stops = slices.map(slice => {
      const start = acc;
      acc += slice.percent;
      return `${slice.color} ${start}% ${acc}%`;
    });
    if (acc < 100) {
      stops.push(`var(--color-gray-light) ${acc}% 100%`);
    }
    return `conic-gradient(${stops.join(', ')})`;
  }, [slices]);

  const legend = useMemo(
    () => [...slices].sort((a, b) => b.percent - a.percent),
    [slices],
  );

  return (
    <div className={cn('donut')}>
      <div className={cn('donut-chart')} style={{ background: gradient }}>
        <div className={cn('donut-chart-hole')}>
          <span className={cn('donut-chart-value')}>{centerValue}</span>
          <span className={cn('donut-chart-label')}>{centerLabel}</span>
        </div>
      </div>
      <div className={cn('donut-legend')}>
        {legend.map(item => (
          <div key={item.label} className={cn('donut-legend-row')}>
            <div className={cn('donut-legend-left')}>
              <span className={cn('donut-legend-dot')} style={{ backgroundColor: item.color }} />
              <span className={cn('donut-legend-name')}>{item.label}</span>
            </div>
            <span className={cn('donut-legend-percent')}>{item.percent}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export function formatTopicTime(sec: number): string {
  const label = formatSecondsShort(sec);
  if (sec >= 600) return `~${label}`;
  return label;
}

export default SpeakerDonutChart;
